import React from 'react';
import { AppBar, Toolbar, Box, CircularProgress, Typography } from '@mui/material';

const LoadingScreen = ({ authLoading, inProgress }) => {
  return (
    <>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', p: 0 }}
      >
        <Toolbar sx={{ justifyContent: 'flex-start', alignItems: 'center', minHeight: 56, px: 3 }}>
          <Box component="img" src="/images/group-1.svg" alt="DCLI" sx={{ height: 24, display: 'block' }} />
        </Toolbar>
      </AppBar>

      <Box
        className="loading-screen"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: 'calc(100vh - 56px)',
          bgcolor: '#fff'
        }}
      >
        <CircularProgress color="primary" sx={{ mb: 2 }} />
        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          {inProgress === 'login' && 'Signing in...'}
          {inProgress === 'logout' && 'Signing out...'}
          {authLoading && 'Please wait...'}
        </Typography>
      </Box>
    </>
  );
};

export default LoadingScreen;
